module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('plotlyjs-basic-chart', {
    attrs: {
      "target-id": _vm.targetId,
      "target-css-classes": _vm.cssClasses,
      "bc-options": _vm.mergeDicts(_vm.defaultOptions, _vm.bcOptions),
      "height": _vm.height,
      "width": _vm.width,
      "bc-data": _vm.bcData,
      "bc-layout": _vm.bcLayout
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f1dd3e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/PlotlyJS/LSBasicChart.vue
// module id = 613
// module chunks = 0